"use client";

import ContactForm from "@/components/ContacForm";
import { handleParse } from "@/lib/handleParse";
import { ContactFormSektion } from "@/types/page";
import React from "react";

export default function ContactFormLayout({
  content,
}: {
  content: ContactFormSektion;
}) {
  return (
    <section className="layout">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-14">
        {content?.text && handleParse(content.text)}
        <div>
          <ContactForm />
        </div>
      </div>
    </section>
  );
}
